import { useQuery } from '@tanstack/react-query';
import { useTerminalClient } from '../client-rpc-router';
import { TerminalScreen } from '../components/TerminalScreen';

export default function MyWarehouseRelationsPage() {
	const client = useTerminalClient();
	const { data } = useQuery({
		queryKey: ['my-warehouse-relations'],
		queryFn: () => client.warehouseRelations.getAllMyWarehouseRelationsQuery.execute({})
	});

	return (
		<TerminalScreen showBackButton topBar={<div>Moje sklady</div>}>
			<div className="p-4">
				{data?.map(relation => (
					<div key={relation.id} className="mb-2">
						{relation?.warehouse?.name} ({relation?.warehouse?.code})
					</div>
				))}
			</div>
		</TerminalScreen>
	);
}
